import { render, staticRenderFns } from "./DiabetesTypeTwo.vue?vue&type=template&id=5a9f17c0&scoped=true&"
import script from "./DiabetesTypeTwo.vue?vue&type=script&lang=js&"
export * from "./DiabetesTypeTwo.vue?vue&type=script&lang=js&"
import style0 from "./DiabetesTypeTwo.vue?vue&type=style&index=0&id=5a9f17c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f17c0",
  null
  
)

export default component.exports